import Axios from '@/plugins/Axios';
import { GetOrderStatusInterface } from '@/types';
import { AxiosResponse } from 'axios';

type OrderStatusParamsType = {
  time_period?: string;
  sort_by: string;
};

const PrescriptionApi = {
  getOrderStatus: (params: OrderStatusParamsType) => {
    return Axios().get<GetOrderStatusInterface[]>(`/b2b/order-status`, {
      params,
    });
  },
};

export default PrescriptionApi;
